export const LegalPage = ({ title, updated, children, testId }) => (
  <main data-testid={testId} className="pt-16">
    <section className="py-16 border-b border-[#2A3042]">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <p className="text-xs uppercase tracking-[0.25em] font-bold text-[#FF453A] mb-4">Legal</p>
        <h1 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tighter text-white">{title}</h1>
        <p className="mt-4 text-sm text-[#5a6070]">Last updated: {updated}</p>
      </div>
    </section>
    <section className="py-14">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 legal-body">{children}</div>
    </section>
  </main>
);

export const H = ({ children }) => (
  <h2 className="font-heading font-semibold text-xl text-white mt-10 mb-3">{children}</h2>
);
export const P = ({ children }) => (
  <p className="text-[15px] text-[#9BA1B0] leading-relaxed mb-4">{children}</p>
);
export const LI = ({ children }) => (
  <li className="text-[15px] text-[#9BA1B0] leading-relaxed mb-2 ml-5 list-disc">{children}</li>
);
